<template>
    <section>
        <h1 class="title">
            Declaración Compromisos PDF
            <hr class="dropdown-divider" aria-role="menuitem">
        </h1>

        <div class="columns is-centered">
            <div class="column has-text-centered">
                <b-button icon-left="search-plus" type="is-primary is-light" @click="zoom += 10"
                    :disabled="zoom >= 200" />
                <b-button icon-right="search-minus" type="is-primary is-light" @click="zoom -= 10"
                    :disabled="zoom <= 100" />
            </div>
        </div>

        <div v-if="!isLoading" class="columns is-centered">
            <div class="column is-8 has-text-centered is-bordered-grey" style="height: 40vh; overflow: auto;">
                <pdf ref="pdf" :page="currentPage" :src="urlPagePdf" @num-pages="pageCount = $event"
                    :style="{ width: `${zoom}%` }" />
            </div>
        </div>

        <div class="columns is-centered">
            <div class="column is-8">
                <div class="columns is-centered">
                    <div class="column has-text-left">
                        <b-button label="Retroceder página" icon-left="arrow-left" type="is-primary"
                            @click="currentPage -= 1" :disabled="currentPage === 1" />
                    </div>
                    <div class="column has-text-centered">
                        Página: {{ currentPage }}/{{ pageCount }}
                    </div>
                    <div class="column has-text-right">
                        <b-button label="Siguiente página" icon-right="arrow-right" type="is-primary"
                            @click="currentPage += 1" :disabled="currentPage === pageCount" />
                    </div>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column is-flex is-justify-content-space-between">
                <b-button label="Volver" icon-left="arrow-left" type="is-info" @click="$emit('close')" />
                <b-button label="Ir a Firmar en SAS" type="is-sas-color" @click="signPerformance" />
            </div>
        </div>
        <b-loading v-model="isLoading" is-full-page />
    </section>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import pdf from "vue-pdf";
export default {

    name: 'DownloadAcademicPerformances',

    props: {
        academicPerformances: {
            type: Object,
            required: true
        },

        academicAreas: {
            type: Array,
            required: true
        }
    },

    components: {
        pdf,
    },

    data() {
        return {
            isLoading: false,

            data: [],
            hours_weekly: 0.0,
            hours_yearly: 0.0,
            hours_eq: 0.0,
            academicInfo: {},

            pdfBlob: null,
            urlPagePdf: null,

            //Controls for the PDF
            currentPage: 1,
            pageCount: null,
            zoom: 100,

            //DATA TO SAS
            google_forms_response: [
                {
                    title: "Correo electrónico",
                    response: null,
                },
                {
                    title: "Nombre Completo",
                    response: null,
                },
                {
                    title: "Rut o pasaporte",
                    response: null,
                },
                {
                    title: "Unidad",
                    response: null,
                },
                {
                    title: "Cargo",
                    response: null,
                }
            ],
        }
    },

    created() {
        this.calculateConsolidated()
    },

    methods: {

        async signPerformance() {
            this.isLoading = true
            let formData = new FormData();
            formData.append('file', this.pdfBlob, 'documento.pdf');
            formData.append('person_id', this.academicPerformances.person_id);
            await axios
                .post(`/performances/${this.academicPerformances.id}/sign.json`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then(response => {
                    this.goToSas(response.data)
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al firmar la declaración de compromisos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        iconPack: 'fa',
                        icon: 'times-circle',
                        confirmText: 'Ok',
                    })
                }).finally(() => {
                    this.isLoading = false
                })
        },

        async goToSas(data) {
            this.google_forms_response[0].response = data.email
            this.google_forms_response[1].response = data.full_name
            this.google_forms_response[2].response = data.rut
            this.google_forms_response[3].response = data.unit_name
            this.google_forms_response[4].response = data.work_plant_name
            let url = `${data.url}?email=${data.email}&google_forms_response=${JSON.stringify(this.google_forms_response)}`
            window.location.href = url
        },

        calculateConsolidated() {
            this.isLoading = true

            this.data = this.academicAreas.map(area => {
                return {
                    academic_area_id: area.id,
                    area: area.alt_name,
                    hours_committed_weekly: 0.0,
                    hours_committed_yearly: 0.0,
                    hours_committed_weekly_1: 0.0,
                    hours_committed_yearly_1: 0.0,
                    hours_committed_weekly_2: 0.0,
                    hours_committed_yearly_2: 0.0,
                    percentage: 0.0,
                }
            })

            this.academicPerformances.activity_performances.forEach(performance => {
                let area = this.data.find(area => area.academic_area_id === performance.academic_area_id)
                let area_index = this.data.findIndex(area => area.academic_area_id === performance.academic_area_id)
                if (area) {
                    if (performance.is_weekly_hours) {
                        area.hours_committed_weekly_1 += parseFloat(performance.hours_committed_semester_1)
                        area.hours_committed_weekly_2 += parseFloat(performance.hours_committed_semester_2)
                    } else {
                        area.hours_committed_yearly_1 += parseFloat(performance.hours_committed_semester_1)
                        area.hours_committed_yearly_2 += parseFloat(performance.hours_committed_semester_2)

                    }
                    this.data[area_index] = area
                }
            })

            let total = 0.0

            this.data.forEach(area => {
                area.hours_committed_weekly = parseFloat(((area.hours_committed_weekly_1 + area.hours_committed_weekly_2) / 2).toFixed(1))
                area.hours_committed_yearly = parseFloat(((area.hours_committed_yearly_1 + area.hours_committed_yearly_2) / 2).toFixed(1))
                total += area.hours_committed_weekly * 36 + area.hours_committed_yearly
            })

            this.hours_weekly = parseFloat((this.data.reduce((acc, area) => acc + area.hours_committed_weekly, 0.0)).toFixed(1))
            this.hours_yearly = parseFloat((this.data.reduce((acc, area) => acc + area.hours_committed_yearly, 0.0)).toFixed(1))

            this.hours_eq = parseFloat(((this.hours_weekly * 36 + this.hours_yearly) / 44).toFixed(1))

            this.getAcademicInfo()
        },

        async getAcademicInfo() {
            await axios
                .get(`/people/${this.academicPerformances.person_id}/my-all-academic-data.json`)
                .then(async response => {
                    this.academicInfo = response.data
                    await this.downloadPDF()
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        iconPack: 'fa',
                        icon: 'times-circle',
                        confirmText: 'Ok',
                    })
                }).finally(() => {
                    this.isLoading = false
                })
        },

        async downloadPDF() {
          let width = 216; // 8.5 pulgadas en mm
          let height = 356; // 14 pulgadas en mm
          let doc = new jsPDF({orientation: "landscape", format: [width, height],});
          // Dimensiones de la página
          let pageWidth = doc.internal.pageSize.width;

          // HEADER
          doc.setFont("helvetica", "bold");
          doc.setFontSize(11);
          let header = ['UNIVERSIDAD DE SANTIAGO DE CHILE', 'FACULTAD DE INGENIERÍA', this.academicInfo.unit_assigned.toUpperCase()];
          doc.text(header, 10, 15);

          // TITLE
          let blockTitlePosition = 25;
          doc.setFontSize(12);

          let title = 'DECLARACIÓN DE COMPROMISOS DE DESEMPEÑO';
          let titleWidth = doc.getTextWidth(title);
          let titleX = (pageWidth - titleWidth) / 2;
          doc.text(title, titleX, blockTitlePosition);


          blockTitlePosition += 6;
          title = 'ACADÉMICOS CUERPO REGULAR';
          titleWidth = doc.getTextWidth(title);
          titleX = (pageWidth - titleWidth) / 2;
          doc.text(title, titleX, blockTitlePosition);

          blockTitlePosition += 6;
          title = `AÑO ${this.academicPerformances.year}`;
          titleWidth = doc.getTextWidth(title);
          titleX = (pageWidth - titleWidth) / 2;
          doc.text(title, titleX, blockTitlePosition);

          // Configuration for all tables performances
          let tableMargin = 12;
          let tableWidth = pageWidth - (tableMargin * 2);
          let marginLeft = (pageWidth - tableWidth) / 2;

          // ACADEMIC INFORMATION
          let blockAcademicInformationPosition = blockTitlePosition + 3;
          doc.setFont("helvetica", "bold");
          doc.setFontSize(10);
          doc.text("I. Antecedentes Personales", 11, blockAcademicInformationPosition);

          let columns = [this.academicInfo.person.last_name, this.academicInfo.person.second_surname, this.academicInfo.person.name];
          let rows = [["Primer Apellido", "Segundo Apellido", "Nombres"]];

          blockAcademicInformationPosition += 5;
          doc.autoTable({
            head: [columns],
            body: rows,
            startY: blockAcademicInformationPosition,
            theme: 'plain',
            margin: {left: marginLeft},
            columnStyles: {
              0: {cellWidth: tableWidth * 0.33},
              1: {cellWidth: tableWidth * 0.33},
              2: {cellWidth: tableWidth * 0.33},
            },
            styles: {
              fontSize: 8,
              textColor: [0, 0, 0],
              fillColor: [255, 255, 255],
              halign: "center",
            },
            headStyles: {
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
              fontSize: 8,
              fontStyle: "bold",
              halign: "center",
            },
            bodyStyles: {
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
              halign: "center",
            },
          });

          columns = [this.academicInfo.faculty_assigned, this.academicInfo.unit_assigned, this.academicInfo.hierarchy_name, this.academicInfo.working_day_name];
          rows = [["Facultad", "Departamento", "Jerarquía", "Jornada"]];

          blockAcademicInformationPosition += 15;
          doc.autoTable({
            head: [columns],
            body: rows,
            startY: blockAcademicInformationPosition,
            theme: 'plain',
            margin: {left: marginLeft},
            columnStyles: {
              0: {cellWidth: tableWidth * 0.25},
              1: {cellWidth: tableWidth * 0.25},
              2: {cellWidth: tableWidth * 0.25},
              3: {cellWidth: tableWidth * 0.25},
            },
            styles: {
              fontSize: 8,
              textColor: [0, 0, 0],
              fillColor: [255, 255, 255],
              halign: "center",
            },
            headStyles: {
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
              fontSize: 8,
              fontStyle: "bold",
              halign: "center",
            },
            bodyStyles: {
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
              halign: "center",
            },
          });

          let blockAcademicPerformancePosition = blockAcademicInformationPosition + 18;

          columns = ["Áreas Académicas", "Horas/Semana Comprometidas", "Horas/Año Comprometidas"];
          rows = this.data.map(area => {
            return [area.area, String(area.hours_committed_weekly), String(area.hours_committed_yearly)]
          });

          doc.autoTable({
            head: [columns],
            body: rows,
            startY: blockAcademicPerformancePosition,
            theme: 'grid',
            margin: {left: marginLeft},
            columnStyles: {
              0: {cellWidth: tableWidth * 0.4},
              1: {cellWidth: tableWidth * 0.3},
              2: {cellWidth: tableWidth * 0.3},
            },
            styles: {
              fontSize: 8,
              textColor: [0, 0, 0],
              fillColor: [255, 255, 255],
              halign: "left",
            },
            headStyles: {
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
              lineColor: 200,
              lineWidth: 0.25,
              fontSize: 8,
              fontStyle: "bold",
              halign: "left",
            },
            bodyStyles: {
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
              halign: "left",
            },
          });

          columns = ["", "Semanales", "Anuales"];
          rows = [
            ["Horas Cronológicas Promedio Anual", String(this.hours_weekly), String(this.hours_yearly)],
            ["Horas Semanales Equivalentes Totales", {
              content: String(this.hours_eq),
              colSpan: 2,
              styles: {halign: "center"}
            }],
          ];

          blockAcademicPerformancePosition += 56;
          doc.autoTable({
            head: [columns],
            body: rows,
            startY: blockAcademicPerformancePosition,
            theme: 'grid',
            margin: {left: marginLeft},
            columnStyles: {
              0: {cellWidth: tableWidth * 0.4},
              1: {cellWidth: tableWidth * 0.3},
              2: {cellWidth: tableWidth * 0.3},
            },
            styles: {
              fontSize: 8,
              textColor: [0, 0, 0],
              fillColor: [255, 255, 255],
              halign: "left",
            },
            headStyles: {
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
              lineColor: 200,
              lineWidth: 0.25,
              fontSize: 8,
              fontStyle: "bold",
              halign: "left",
            },
            bodyStyles: {
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
              halign: "left",
            },
          });

          //SIGANTURES
          let blockSignaturesPosition = blockAcademicPerformancePosition + 48;

          let lineLength = 80; // Length of the line
          let lineSpacing = 30; // Spacing between lines
          let textOffset = 5;

          // First line for signatures
          let firstLineX1 = (pageWidth / 2) - lineLength - (lineSpacing / 2);
          let firstLineX2 = firstLineX1 + lineLength;
          let text1X = firstLineX1 + lineLength / 2;
          let text1Y = blockSignaturesPosition + textOffset;
          let academicCharge = ''
          if (this.academicInfo.person.gender_name === "HOMBRE") {
            academicCharge = "Académico"
          } else if (this.academicInfo.person.gender_name === "MUJER") {
            academicCharge = "Académica"
          } else {
            academicCharge = "Académico(a)"
          }
          doc.text(this.academicInfo.person.name + ' ' + this.academicInfo.person.last_name + ' ' + this.academicInfo.person.second_surname, text1X, text1Y, {align: "center"});
          doc.text(academicCharge, text1X, text1Y + 5, {align: "center"});

          // Second line for signatures
          let secondLineX1 = (pageWidth / 2) + (lineSpacing / 2);
          let secondLineX2 = secondLineX1 + lineLength;
          let text2X = secondLineX1 + lineLength / 2;
          let text2Y = blockSignaturesPosition + textOffset;
          let directorCharge = ''
          if (this.academicInfo.director_gender === "HOMBRE") {
            directorCharge = "Director de Departamento"
          } else if (this.academicInfo.director_gender === "MUJER") {
            directorCharge = "Directora de Departamento"
          } else {
            directorCharge = "Director(a) de Departamento"
          }
          doc.text(this.academicInfo.director_name, text2X, text2Y, {align: "center"});
          doc.text(directorCharge, text2X, text2Y + 5, {align: "center"});

          doc.line(firstLineX1, blockSignaturesPosition, firstLineX2, blockSignaturesPosition); // First line
          doc.line(secondLineX1, blockSignaturesPosition, secondLineX2, blockSignaturesPosition); // Second Line

          // TABLES Performances
          let tableConfig = {
            startY: 20,
            theme: 'grid',
            margin: {left: marginLeft},
            columnStyles: {
              0: {cellWidth: tableWidth * 0.30},
              1: {cellWidth: tableWidth * 0.10},
              2: {cellWidth: tableWidth * 0.10},
              3: {cellWidth: tableWidth * 0.10},
              4: {cellWidth: tableWidth * 0.10},
              5: {cellWidth: tableWidth * 0.30},
            },
            styles: {
              fontSize: 8,
              textColor: [0, 0, 0],
              fillColor: [255, 255, 255],
              halign: "left",
            },
            headStyles: {
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
              lineColor: 200,
              lineWidth: 0.25,
              fontSize: 8,
              fontStyle: "bold",
              halign: "left",
            },
            bodyStyles: {
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
              halign: "left",
            },
          };

          this.academicAreas.forEach((area, index) => {
            doc.addPage();
            if (index === 0) {
              doc.setFont("helvetica", "bold");
              doc.setFontSize(10);
              doc.text("II. Descripción compromisos", 11, 15);
            }

            let total_hours_1_weekly = 0.0
            let total_hours_2_weekly = 0.0
            let total_hours_1_semiannually = 0.0
            let total_hours_2_semiannually = 0.0
            rows = this.academicPerformances.activity_performances
                .filter(performance => performance.academic_area_id === area.id)
                .map(performance => {
                  let activity_name = performance.alt_name_activity;
                  let hours_committed_semester_1_week = performance.is_weekly_hours ? performance.hours_committed_semester_1 : 0.0;
                  let hours_committed_semester_2_week = performance.is_weekly_hours ? performance.hours_committed_semester_2 : 0.0;
                  let hours_committed_semester_1_semiannually = performance.is_weekly_hours ? 0.0 : performance.hours_committed_semester_1;
                  let hours_committed_semester_2_semiannually = performance.is_weekly_hours ? 0.0 : performance.hours_committed_semester_2;
                  if (performance.is_weekly_hours) {
                    total_hours_1_weekly += parseFloat(performance.hours_committed_semester_1)
                    total_hours_2_weekly += parseFloat(performance.hours_committed_semester_2)
                  } else {
                    total_hours_1_semiannually += parseFloat(performance.hours_committed_semester_1)
                    total_hours_2_semiannually += parseFloat(performance.hours_committed_semester_2)
                  }
                  return [activity_name, hours_committed_semester_1_week, hours_committed_semester_1_semiannually, hours_committed_semester_2_week, hours_committed_semester_2_semiannually, performance.observations];
                });

            rows.push(["TOTAL " + area.name, total_hours_1_weekly, total_hours_1_semiannually, total_hours_2_weekly, total_hours_2_semiannually, ""]);

            let header = [
              [
                {content: "", colSpan: 1, rowSpan: 2, styles: {halign: "center", valign: "middle"}},
                {content: "Primer Semestre", colSpan: 2, styles: {halign: 'center'}},
                {content: "Segundo Semestre", colSpan: 2, styles: {halign: 'center'}},
                {content: "Observaciones", colSpan: 1, rowSpan: 3, styles: {halign: "center", valign: "middle"}}
              ],
              [
                {content: "Horas Comprometidas", colSpan: 2, styles: {halign: 'center'}},
                {content: "Horas Comprometidas", colSpan: 2, styles: {halign: 'center'}},
              ],
              [area.name, "Semana", "Semestre", "Semana", "Semestre"]
            ]

            doc.autoTable({
              head: header,
              body: rows,
              ...tableConfig,
            });
          });


          // Agregar logo en el lado derecho
          let imgPath = "/logo_negro_facultad_ing.png"; // Ruta del logo en la carpeta public
          let imgWidth = 60; // Ancho de la imagen
          let imgHeight = 0; // Alto de la imagen segun proporciones originales
          let imgX = pageWidth - imgWidth - 10; // Calcula la posición para el lado derecho
          let imgY = 5; // Posición vertical

          const response = await fetch(imgPath);
          const blob = await response.blob();

          // Convertir el Blob en una cadena Base64
          const base64Image = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob); // Convierte el blob en Base64
          });

          // Crear una imagen y cargar el logo
          let img = new Image();
          img.src = imgPath;
          img.onload = () => {
            doc.setPage(1);
            doc.addImage(base64Image, "PNG", imgX, imgY, imgWidth, imgHeight);
            this.pdfBlob = doc.output("blob");
            this.urlPagePdf = URL.createObjectURL(this.pdfBlob);
            this.isLoading = false
          }
        }
    }
}
</script>